import { LocalDrinkSharp } from '@material-ui/icons';
import React from 'react';
import { AssetReadinessStyle } from "./AssetReadinessStyle";
import Popover from '@material-ui/core/Popover';
import { Button } from '@material-ui/core';
import FormatService from '../../../../services/formatService';

const AssetReadiness = ({ readinessStatus = {}, isReady = false, isWash = false, isInspection = false }) => {
    const classes = AssetReadinessStyle();

    let buttonColor = readinessStatus?.status;
    if (isWash) {
        buttonColor = readinessStatus?.washStatus;
    }
    if (isInspection) {
        buttonColor = readinessStatus?.ameritInspectionStatus;
    }

    const [anchorEl, setAnchorEl] = React.useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(false);
    };

    const open = Boolean(anchorEl);
    let name = (buttonColor === 1) ? 'Ready' : 'Not Ready';
    if (isWash) {
        name = 'Washed';
    }
    if (isInspection) {
        name = 'Inspected';
    }
    let status = buttonColor === 1 ? 'Ready' : 'Not Ready';

    // if (isWash) {
    //     if (buttonColor === 1) {
    //         status = 'Washed within the Month'
    //     }
    //     if (buttonColor === 2) {
    //         status = 'Washed within 30-37 Days'
    //     }
    //     if (buttonColor === 3) {
    //         status = 'Washed > 37 Days'
    //     }
    // }
    // if (isInspection) {
    //     if (buttonColor === 1) {
    //         status = 'Inspected within 2 Weeks'
    //     }
    //     if (buttonColor === 2) {
    //         status = 'Inspected within 2-3 Weeks'
    //     }
    //     if (buttonColor === 3) {
    //         status = 'Inspected > 3 Weeks'
    //     }
    // }

    const isInDetails = (!isReady && !isWash && !isInspection)

    return (
        <>
            {buttonColor &&
                <div className={`${isInDetails && classes.indicatorDetailsWrapper} ${classes.indicatorWrapper}`}>

                    {!isReady && !isInDetails &&
                        <>
                            <Indicator
                                onOpen={handleClick}
                                onClose={handleClose}
                                status={buttonColor}
                            />
                            <div className={isInDetails ? classes.indicatorDetailsText : classes.indicatorText}>{name}</div>
                        </>
                    }

                    {(isReady || isInDetails) &&
                        <div onClick={handleClick}>
                            <div className={`${buttonColor === 1 ? classes.greenIndicator : buttonColor === 2 ? classes.yellowIndicator : classes.redIndicator} ${classes.ready}`}>{name}</div>
                        </div>
                    }

                    <Popover
                        //id={asset.id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <div className={classes.tooltipContent}>
                            <div className={classes.tooltipField}><label>Status: </label>{status}</div>
                            {readinessStatus?.pickupDate && <div className={classes.tooltipField}><label>Load pickup date: </label>{FormatService.formatDate(readinessStatus?.pickupDate)}</div>}
                            {(isReady || isInDetails || isWash) && readinessStatus?.washStatus && <div className={classes.tooltipField}><label>Latest Wash Date: </label>{readinessStatus?.latestCompletedWash ? FormatService.formatDate(readinessStatus?.latestCompletedWash) : 'Unknown'}<Indicator status={readinessStatus?.washStatus} className={classes.tooltipIndicator} /></div>}
                            {(isReady || isInDetails || isInspection) && readinessStatus?.ameritInspectionStatus && <div className={classes.tooltipField}><label>Latest Amerit Inspection: </label>{readinessStatus.latestAmeritInspection ? FormatService.formatDate(readinessStatus?.latestAmeritInspection) : 'Unknown'}<Indicator status={readinessStatus?.ameritInspectionStatus} className={classes.tooltipIndicator} /></div>}
                            {(isReady || isInDetails || isWash) && readinessStatus?.requestedWashInterval && <div className={classes.tooltipField}><label>Requested Wash Interval: </label>{readinessStatus?.requestedWashInterval}</div>}
                        </div>
                    </Popover>
                </div>
            }
        </>
    )
}

export default AssetReadiness;

const Indicator = ({ status, onOpen, onClose, className }) => {

    const classes = AssetReadinessStyle();
    const statusToClass = {
        1: classes.greenIndicator,
        2: classes.yellowIndicator,
        3: classes.redIndicator
    }
    return (
        <span
            className={`${statusToClass[status]} ${classes.indicator} ${className}`}
            //onMouseEnter={onOpen}
            //onMouseLeave={onClose}
            onClick={onOpen}
        />
    );
}